module.exports = __webpack_public_path__ + "img/9788952759924.a61ad02b.jpg";